import React from 'react';
import LoadingIndicator from '../../LoadingIndicator';
import DaEditorMonoView from '../Views/Mono';
// TODO lazy loading...
export class Image extends React.Component {
    render() {
        const { data, width, config, isHtml, settings } = this.props;
        if (!data) {
            return /*#__PURE__*/ React.createElement(LoadingIndicator, {
                view: "llama"
            });
        }
        return /*#__PURE__*/ React.createElement(DaEditorMonoView, {
            settings: settings,
            config: config,
            deviation: data,
            width: width,
            isHtml: isHtml
        });
    }
}
